import * as React from "react";
import { Grid, FormControl, InputLabel, Select, MenuItem } from "@mui/material";
// import { isValid, startOfDay, endOfDay } from "date-fns";
import PropTypes from "prop-types";
import { Input } from "rbx";
// import { styled } from '@mui/material/styles';
// import { useAuth } from "../../../context";
// import { Role } from "../../generated/graphql";
// import CodeSelect from "../../CodeSelect";
// import DateInput from "../../DateInput";
import EmployeeSelectAlt from "../../EmployeeSelectAlt";
// import StatusSelect from "../../StatusSelect";
// import LevelSelect from "../../LevelSelect";
// import ProjectSelect from "../../ProjectSelect";
// import GenericSelect from "../../GenericSelect/GenericSelect";
import GroupCycleSelect from "../../GroupCycleSelect/GroupCycleSelect";
import { GroupSelectMUI } from "../..";
import DateRangePicker from "../../DateRangePicker/DateRangePicker";
import checkMobile from "../../../utils/checkForMobile";

function SearchFiltersForm({ inputs, onChange, location, setFilters }) {
  const [subjectSearchValue, setSubjectSearchValue] = React.useState("");
  const isMobile = checkMobile();

  // Helpers to prefill owner/author fields from current where
  const getContainsValues = (field) => {
    const conditions = (inputs?.AND || []).filter((c) => c?.[field]?.contains);
    return conditions.map((c) => c[field].contains);
  };

  const [prefill, setPrefill] = React.useState({
    ownerFirst: "",
    ownerLast: "",
    authorFirst: "",
    authorLast: "",
  });

  // Sync local state with external filter resets
  React.useEffect(() => {
    if (!inputs?.user && !inputs?.OR) {
      setSubjectSearchValue("");
    }
  }, [inputs?.user, inputs?.OR]);

  // Prefill for PPA modal from AND conditions
  React.useEffect(() => {
    if (location !== "ppa-assignments") return;
    const ownerVals = getContainsValues("owner");
    const authorVals = getContainsValues("formAuthor");
    // Populate first and last explicitly: single value -> first, two values -> first + last
    setPrefill({
      ownerFirst: ownerVals[0] || "",
      ownerLast: ownerVals.length > 1 ? ownerVals[1] : "",
      authorFirst: authorVals[0] || "",
      authorLast: authorVals.length > 1 ? authorVals[1] : "",
    });
  }, [inputs?.AND, location]);

  // TO DO replace with dynamic options
  const yearOptions = [
    "2023",
    "2024",
    "2025",
    "2026",
    "2027",
    "2028",
    "2029",
    "2030",
  ];


  const checkNeedsAssignment = () => {
    if (typeof inputs?.needsAssignment === "object") {
      return inputs?.needsAssignment?.equals ? "Yes" : "No";
    } if (typeof inputs?.needsAssignment === "string") {
      return inputs?.needsAssignment;
    }
    return "";

  };

  const needsAssignment = checkNeedsAssignment();
  // TO DO replace with dynamic options
  const reviewStatusOptions = ["INCOMPLETE", "COMPLETED", "SAVE_FOR_LATER"];

  const overdueOptions = ["Yes", "No"];
  const needsAssignmentOptions = ["Yes", "No"];
  

  const convertEnum = (value) =>
    value
      .toLowerCase()
      .split("_")
      .map((x) => `${x.charAt(0).toUpperCase()}${x.slice(1)}`)
      .join(" ");

  if (location === "workshop") {
    return (
      <Grid container columnSpacing={1} rowSpacing={2}>
        <Grid item xs={isMobile ? 12 : 4}>
          <InputLabel
            sx={{ fontWeight: "bold", color: "black", marginTop: "8px" }}
          >
            Year
          </InputLabel>
          <FormControl sx={{ m: 0, width: 200, marginLeft: "-8px" }}>
            <Select
              fullWidth
              SelectDisplayProps={{
                style: { padding: "6.5px 10px" },
                width: "200px",
              }}
              name="year"
              sx={{ m: 1, minWidth: 120 }}
              value={inputs?.year?.equals || inputs?.year || ""}
              variant="outlined"
              onChange={(e) => onChange(e.target.name, e.target.value)}
            >
              <MenuItem key="_blank" value="" />
              {Array.isArray(yearOptions) &&
                yearOptions.map((year) => (
                  <MenuItem key={year} value={year}>
                    {year}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={isMobile ? 12 : 4}>
          <InputLabel
            sx={{ fontWeight: "bold", color: "black", margin: " 8px 0px" }}
          >
            Title
          </InputLabel>
          <FormControl sx={{ m: 0, width: 200 }}>
            <Input
              fullWidth
              label="Title"
              value={inputs?.title?.contains || inputs?.title || ""}
              onChange={(e) => onChange("title", e.target.value)}
            />
            {/*  User */}
          </FormControl>
        </Grid>
      </Grid>
    );
  }

  if (location === "reviews") {
    return (
      <Grid container columnSpacing={1} rowSpacing={2}>
        <Grid item xs={isMobile ? 12 : 4}>
          <InputLabel
            sx={{ fontWeight: "bold", color: "black", marginTop: "8px" }}
          >
            Status
          </InputLabel>
          <FormControl sx={{ m: 0, width: 200, marginLeft: "-8px" }}>
            <Select
              fullWidth
              SelectDisplayProps={{
                style: { padding: "6.5px 10px" },
                width: "200px",
              }}
              name="status"
              sx={{ m: 1, minWidth: 120 }}
              value={inputs?.status?.equals || inputs?.status || ""}
              variant="outlined"
              onChange={(e) => onChange(e.target.name, e.target.value)}
            >
              <MenuItem key="_blank" value="" />
              {Array.isArray(reviewStatusOptions) &&
                reviewStatusOptions.map((status) => (
                  <MenuItem key={status} value={status}>
                    {convertEnum(status)}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={isMobile ? 12 : 4}>
          <InputLabel
            sx={{ fontWeight: "bold", color: "black", marginTop: "8px" }}
          >
            Overdue
          </InputLabel>
          <FormControl sx={{ m: 0, width: 200, marginLeft: "-8px" }}>
            <Select
              fullWidth
              SelectDisplayProps={{
                style: { padding: "6.5px 10px" },
                width: "200px",
              }}
              name="overdue"
              sx={{ m: 1, minWidth: 120 }}
              value={inputs?.overdue?.equals || inputs?.overdue || ""}
              variant="outlined"
              onChange={(e) => onChange(e.target.name, e.target.value)}
            >
              <MenuItem key="_blank" value="" />
              {Array.isArray(overdueOptions) &&
                overdueOptions.map((overdue) => (
                  <MenuItem key={overdue} value={overdue}>
                    {overdue}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={isMobile ? 12 : 4}>
          <InputLabel
            sx={{ fontWeight: "bold", color: "black", margin: " 8px 0px" }}
          >
            Title
          </InputLabel>
          <FormControl sx={{ m: 0, width: 200 }}>
            <Input
              fullWidth
              label="Title"
              value={inputs?.title?.contains || inputs?.title || ""}
              onChange={(e) => onChange("title", e.target.value)}
            />
            {/*  User */}
          </FormControl>
        </Grid>
        <Grid item xs={isMobile ? 12 : 4}>
          <FormControl
            sx={{ m: 0, minWidth: 120, marginTop: "8px" }}
            variant="standard"
          >
            <EmployeeSelectAlt
              showBlank
              useName
              label="Manager"
              name="manager"
              placeholder="Manager"
              value={inputs?.manager?.equals || inputs?.manager || ""}
              onChange={onChange}
            />
          </FormControl>
        </Grid>
        <Grid item xs={isMobile ? 12 : 4}>
          <DateRangePicker
            label="Date Completed"
            name="dateCompleted"
            value={inputs?.dateCompleted}
            onChange={onChange}
          />
        </Grid>
        <Grid item xs={isMobile ? 12 : 4}>
          <DateRangePicker
            label="Date Due"
            name="dateToCompleteBy"
            value={inputs?.dateToCompleteBy}
            onChange={onChange}
          />
        </Grid>

        <Grid item xs={isMobile ? 12 : 4}>
          <InputLabel
            sx={{ fontWeight: "bold", color: "black", marginTop: "8px" }}
          >
            Year
          </InputLabel>
          <FormControl sx={{ m: 0, width: 200, marginLeft: "-8px" }}>
            <Select
              fullWidth
              SelectDisplayProps={{
                style: { padding: "6.5px 10px" },
                width: "200px",
              }}
              name="year"
              sx={{ m: 1, minWidth: 120 }}
              value={inputs?.year?.equals || inputs?.year || ""}
              variant="outlined"
              onChange={(e) => onChange(e.target.name, e.target.value)}
            >
              <MenuItem key="_blank" value="" />
              {Array.isArray(yearOptions) &&
                yearOptions.map((year) => (
                  <MenuItem key={year} value={year}>
                    {year}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={isMobile ? 12 : 4}>
          <InputLabel
            sx={{ fontWeight: "bold", color: "black", margin: " 8px 0px" }}
          >
            Subject
          </InputLabel>
          <FormControl sx={{ m: 0, width: 200 }}>
            <Input
              fullWidth
              label="Subject"
              placeholder="First name, last name, or both"
              value={subjectSearchValue}
              onChange={({ target: { value } }) => {
                setSubjectSearchValue(value);

                if (value?.trim()) {
                  const searchTerms = value.trim().split(/\s+/);
                  if (searchTerms.length === 1) {
                    // Single term - use top-level OR to search both first and last name
                    onChange("OR", [
                      { user: { is: { firstName: { contains: searchTerms[0], mode: "insensitive" } } } },
                      { user: { is: { lastName: { contains: searchTerms[0], mode: "insensitive" } } } }
                    ]);
                    onChange("user", null); // Clear user filter to avoid conflicts
                  } else {
                    // Multiple terms - search first and last name together  
                    onChange("user", {
                      is: {
                        firstName: { contains: searchTerms[0], mode: "insensitive" },
                        lastName: { contains: searchTerms[1], mode: "insensitive" }
                      }
                    });
                    onChange("OR", null); // Clear OR when using user filter
                  }
                } else {
                  onChange("user", null);
                  onChange("OR", null);
                }
              }}
            />
          </FormControl>
        </Grid>
      </Grid>
    );
  }

  if (location === "evaluations") {
    return (
      <Grid container columnSpacing={1} rowSpacing={2}>
        <Grid item xs={isMobile ? 12 : 4}>
          <DateRangePicker
            label="Date Completed"
            name="dateCompleted"
            value={inputs?.dateCompleted}
            onChange={onChange}
          />
        </Grid>
        <Grid item xs={isMobile ? 12 : 4}>
          <DateRangePicker
            label="Date Due"
            name="dateToCompleteBy"
            value={inputs?.dateToCompleteBy}
            onChange={onChange}
          />
        </Grid>
        <Grid item xs={isMobile ? 12 : 4}>
          <DateRangePicker
            label="Assignment Date"
            name="assignmentDate"
            value={inputs?.assignmentDate}
            onChange={onChange}
          />
        </Grid>
        <Grid item xs={isMobile ? 12 : 4}>
          <FormControl
            sx={{ m: 0, minWidth: 120, marginTop: "8px" }}
            variant="standard"
          >
            <EmployeeSelectAlt
              showBlank
              useName
              label="Manager"
              name="manager"
              placeholder="Manager"
              value={inputs?.manager?.equals || inputs?.manager || ""}
              onChange={onChange}
            />
          </FormControl>
        </Grid>
        <Grid item xs={isMobile ? 12 : 4}>
          <FormControl
            sx={{ m: 0, minWidth: 120, marginTop: "8px" }}
            variant="standard"
          >
            <EmployeeSelectAlt
              showBlank
              useName
              label="Subject"
              name="user"
              placeholder="Subject"
              value={inputs?.owner?.equals || inputs?.owner || inputs?.user?.equals || inputs?.user || ""}
              onChange={onChange}
            />
          </FormControl>
        </Grid>
        <Grid item xs={isMobile ? 12 : 4}>
          <FormControl
            sx={{ m: 0, minWidth: 120, marginTop: "8px" }}
            variant="standard"
          >
            <EmployeeSelectAlt
              showBlank
              useName
              label="Writer"
              name="formAuthor" // for data accuracy, the author field will refer to the writer
              placeholder="Writer"
              value={inputs?.formAuthor?.equals || inputs?.formAuthor || ""}
              onChange={onChange}
            />
          </FormControl>
        </Grid>
        <Grid item xs={isMobile ? 12 : 4}>
          <FormControl
            sx={{ m: 0, minWidth: 120, marginTop: "8px" }}
            variant="standard"
          >
            <EmployeeSelectAlt
              showBlank
              useName
              label="Signer"
              name="signerName" // THE SIGNER WILL BE THE AUTHOR AT THE END
              placeholder="Signer"
              value={inputs?.signerName?.equals || inputs?.signerName || ""}
              onChange={onChange}
            />
          </FormControl>
        </Grid>
        <Grid item xs={isMobile ? 12 : 4}>
          <FormControl
            sx={{ m: 0, minWidth: 120, marginTop: "8px" }}
            variant="standard"
          >
            <EmployeeSelectAlt
              showBlank
              useName
              label="Current Author"
              name="author"
              placeholder="Author"
              value={inputs?.author?.equals || inputs?.author || ""}
              onChange={onChange}
            />
          </FormControl>
        </Grid>
        <Grid item xs={isMobile ? 12 : 4}>
          <FormControl
            sx={{ m: 0, minWidth: 120, marginTop: "8px" }}
            variant="standard"
          >
            <EmployeeSelectAlt
              showBlank
              useEmployeeNumber
              label="Manager Employee Number"
              name="managerEmployeeNumber"
              placeholder="Manager Employee Number"
              value={
                inputs?.managerEmployeeNumber?.equals ||
                inputs?.managerEmployeeNumber ||
                ""
              }
              onChange={onChange}
            />
          </FormControl>
        </Grid>
        <Grid item xs={isMobile ? 12 : 4}>
          <FormControl
            sx={{ m: 0, minWidth: 120, marginTop: "8px" }}
            variant="standard"
          >
            <EmployeeSelectAlt
              showBlank
              useEmployeeNumber
              label="Writer Employee Number"
              name="formAuthorEmployeeNumber"
              placeholder="Writer Employee Number"
              value={
                inputs?.formAuthorEmployeeNumber?.equals ||
                inputs?.formAuthorEmployeeNumber ||
                ""
              }
              onChange={onChange}
            />
          </FormControl>
        </Grid>
        <Grid item xs={isMobile ? 12 : 4}>
          <FormControl
            sx={{ m: 0, minWidth: 120, marginTop: "8px" }}
            variant="standard"
          >
            <EmployeeSelectAlt
              showBlank
              useEmployeeNumber
              label="Author Employee Number"
              name="authorEmployeeNumber"
              placeholder="Current Author Employee Number"
              value={
                inputs?.authorEmployeeNumber?.equals ||
                inputs?.authorEmployeeNumber ||
                ""
              }
              onChange={onChange}
            />
          </FormControl>
        </Grid>
        <Grid item xs={isMobile ? 12 : 4}>
          <InputLabel
            sx={{ fontWeight: "bold", color: "black", marginTop: "8px" }}
          >
            Status
          </InputLabel>
          <FormControl sx={{ m: 0, width: 200, marginLeft: "-8px" }}>
            <Select
              fullWidth
              SelectDisplayProps={{
                style: { padding: "6.5px 10px" },
                width: "200px",
              }}
              name="status"
              sx={{ m: 1, minWidth: 120 }}
              value={inputs?.status?.equals || inputs?.status || ""}
              variant="outlined"
              onChange={(e) => onChange(e.target.name, e.target.value)}
            >
              <MenuItem key="_blank" value="" />
              {Array.isArray(reviewStatusOptions) &&
                reviewStatusOptions.map((status) => (
                  <MenuItem key={status} value={status}>
                    {convertEnum(status)}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={isMobile ? 12 : 4}>
          <InputLabel
            sx={{ fontWeight: "bold", color: "black", marginTop: "8px" }}
          >
            Overdue
          </InputLabel>
          <FormControl sx={{ m: 0, width: 200, marginLeft: "-8px" }}>
            <Select
              fullWidth
              SelectDisplayProps={{
                style: { padding: "6.5px 10px" },
                width: "200px",
              }}
              name="overdue"
              sx={{ m: 1, minWidth: 120 }}
              value={inputs?.overdue?.equals || inputs?.overdue || ""}
              variant="outlined"
              onChange={(e) => onChange(e.target.name, e.target.value)}
            >
              <MenuItem key="_blank" value="" />
              {Array.isArray(overdueOptions) &&
                overdueOptions.map((overdue) => (
                  <MenuItem key={overdue} value={overdue}>
                    {overdue}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={isMobile ? 12 : 4}>
          <InputLabel
            sx={{ fontWeight: "bold", color: "black", marginTop: "8px" }}
          >
            Needs Assignment
          </InputLabel>
          <FormControl sx={{ m: 0, width: 200, marginLeft: "-8px" }}>
            <Select
              fullWidth
              SelectDisplayProps={{
                style: { padding: "6.5px 10px" },
                width: "200px",
              }}
              name="needsAssignment"
              sx={{ m: 1, minWidth: 120 }}
              value={needsAssignment}
              variant="outlined"
              onChange={(e) => onChange(e.target.name, e.target.value)}
            >
              <MenuItem key="_blank" value="" />
              {Array.isArray(needsAssignmentOptions) &&
                needsAssignmentOptions.map((assignment) => (
                  <MenuItem key={assignment} value={assignment}>
                    {assignment}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={isMobile ? 12 : 4}>
          <InputLabel
            sx={{ fontWeight: "bold", color: "black", margin: " 8px 0px" }}
          >
            Title
          </InputLabel>
          <FormControl sx={{ m: 0, width: 200 }}>
            <Input
              fullWidth
              label="Title"
              value={inputs?.title?.contains || inputs?.title || ""}
              onChange={(e) => onChange("title", e.target.value)}
            />
            {/*  User */}
          </FormControl>
        </Grid>
      </Grid>
    );
  }

  const monthOptions = [
    { value: "1", label: "January" },
    { value: "2", label: "February" },
    { value: "3", label: "March" },
    { value: "4", label: "April" },
    { value: "5", label: "May" },
    { value: "6", label: "June" },
    { value: "7", label: "July" },
    { value: "8", label: "August" },
    { value: "9", label: "September" },
    { value: "10", label: "October" },
    { value: "11", label: "November" },
    { value: "12", label: "December" },
  ];

  if (location === "ppa-assignments") {
    return (
      <Grid container columnSpacing={1} rowSpacing={2}>
        <Grid item xs={isMobile ? 12 : 4}>
          <InputLabel
            sx={{ fontWeight: "bold", color: "black", marginTop: "8px" }}
          >
            Year
          </InputLabel>
          <FormControl sx={{ m: 0, width: 200, marginLeft: "-8px" }}>
            <Select
              fullWidth
              SelectDisplayProps={{
                style: { padding: "6.5px 10px" },
                width: "200px",
              }}
              name="year"
              sx={{ m: 1, minWidth: 120 }}
              value={inputs?.year?.equals || inputs?.year || ""}
              variant="outlined"
              onChange={(e) => onChange(e.target.name, e.target.value)}
            >
              <MenuItem key="_blank" value="" />
              {Array.isArray(yearOptions) &&
                yearOptions.map((year) => (
                  <MenuItem key={year} value={year}>
                    {year}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={isMobile ? 12 : 4}>
          <InputLabel
            sx={{ fontWeight: "bold", color: "black", marginTop: "8px" }}
          >
            Month
          </InputLabel>
          <FormControl sx={{ m: 0, width: 200, marginLeft: "-8px" }}>
            <Select
              fullWidth
              SelectDisplayProps={{
                style: { padding: "6.5px 10px" },
                width: "200px",
              }}
              name="month"
              sx={{ m: 1, minWidth: 120 }}
              value={inputs?.month?.equals || inputs?.month || ""}
              variant="outlined"
              onChange={(e) => onChange(e.target.name, e.target.value)}
            >
              <MenuItem key="_blank" value="" />
              {monthOptions.map((month) => (
                <MenuItem key={month.value} value={month.value}>
                  {month.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={isMobile ? 12 : 4}>
          <InputLabel
            sx={{ fontWeight: "bold", color: "black", marginTop: "8px" }}
          >
            Status
          </InputLabel>
          <FormControl sx={{ m: 0, width: 200, marginLeft: "-8px" }}>
            <Select
              fullWidth
              SelectDisplayProps={{
                style: { padding: "6.5px 10px" },
                width: "200px",
              }}
              name="status"
              sx={{ m: 1, minWidth: 120 }}
              value={inputs?.status?.equals || inputs?.status || ""}
              variant="outlined"
              onChange={(e) => onChange(e.target.name, e.target.value)}
            >
              <MenuItem key="_blank" value="" />
              {Array.isArray(reviewStatusOptions) &&
                reviewStatusOptions.map((status) => (
                  <MenuItem key={status} value={status}>
                    {convertEnum(status)}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={isMobile ? 12 : 4}>
          <FormControl
            sx={{ m: 0, minWidth: 120, marginTop: "8px" }}
            variant="standard"
          >
            <EmployeeSelectAlt
              showBlank
              useName
              label="Manager"
              name="manager"
              placeholder="Manager"
              value={inputs?.manager?.equals || inputs?.manager || ""}
              onChange={onChange}
            />
          </FormControl>
        </Grid>
        <Grid item xs={isMobile ? 12 : 4}>
          <InputLabel
            sx={{ fontWeight: "bold", color: "black", margin: " 8px 0px" }}
          >
            Subject First Name
          </InputLabel>
          <FormControl sx={{ m: 0, width: 200 }}>
            <Input
              fullWidth
              label="Subject First Name"
              value={inputs?.ownerFirst !== undefined ? inputs.ownerFirst : (prefill.ownerFirst || "")}
              onChange={({ target: { value } }) => onChange("ownerFirst", value)}
            />
          </FormControl>
        </Grid>
        <Grid item xs={isMobile ? 12 : 4}>
          <InputLabel
            sx={{ fontWeight: "bold", color: "black", margin: " 8px 0px" }}
          >
            Subject Last Name
          </InputLabel>
          <FormControl sx={{ m: 0, width: 200 }}>
            <Input
              fullWidth
              label="Subject Last Name"
              value={inputs?.ownerLast !== undefined ? inputs.ownerLast : (prefill.ownerLast || "")}
              onChange={({ target: { value } }) => onChange("ownerLast", value)}
            />
          </FormControl>
        </Grid>
        <Grid item xs={isMobile ? 12 : 4}>
          <InputLabel
            sx={{ fontWeight: "bold", color: "black", margin: " 8px 0px" }}
          >
            Assigned PPA First Name
          </InputLabel>
          <FormControl sx={{ m: 0, width: 200 }}>
            <Input
              fullWidth
              label="Assigned PPA First Name"
              value={inputs?.authorFirst !== undefined ? inputs.authorFirst : (prefill.authorFirst || "")}
              onChange={({ target: { value } }) => onChange("authorFirst", value)}
            />
          </FormControl>
        </Grid>
        <Grid item xs={isMobile ? 12 : 4}>
          <InputLabel
            sx={{ fontWeight: "bold", color: "black", margin: " 8px 0px" }}
          >
            Assigned PPA Last Name
          </InputLabel>
          <FormControl sx={{ m: 0, width: 200 }}>
            <Input
              fullWidth
              label="Assigned PPA Last Name"
              value={inputs?.authorLast !== undefined ? inputs.authorLast : (prefill.authorLast || "")}
              onChange={({ target: { value } }) => onChange("authorLast", value)}
            />
          </FormControl>
        </Grid>
      </Grid>
    );
  }

  if (location === "goals") {
    return (
      <Grid container columnSpacing={1} rowSpacing={2}>
        <Grid item xs={isMobile ? 12 : 4}>
          <InputLabel
            sx={{ fontWeight: "bold", color: "black", margin: " 8px 0px" }}
          >
            Partner First Name
          </InputLabel>
          <FormControl sx={{ m: 0, width: 200 }}>
            <Input
              fullWidth
              label="Partner First Name"
              value={inputs?.firstName?.contains || inputs?.firstName || ""}
              onChange={(e) => onChange("firstName", e.target.value)}
            />
          </FormControl>
        </Grid>
        <Grid item xs={isMobile ? 12 : 4}>
          <InputLabel
            sx={{ fontWeight: "bold", color: "black", margin: " 8px 0px" }}
          >
            Partner Last Name
          </InputLabel>
          <FormControl sx={{ m: 0, width: 200 }}>
            <Input
              fullWidth
              label="Partner Last Name"
              value={inputs?.lastName?.contains || inputs?.lastName || ""}
              onChange={(e) => onChange("lastName", e.target.value)}
            />
          </FormControl>
        </Grid>
        <Grid item xs={isMobile ? 12 : 4}>
          <InputLabel
            sx={{ fontWeight: "bold", color: "black", margin: " 8px 0px" }}
          >
            Group
          </InputLabel>
          <FormControl sx={{ m: 0, width: 200 }}>
            <GroupSelectMUI
              showAllOption
              label=""
              name="group"
              value={inputs?.group?.contains || inputs?.group || ""}
              getValue={(x) => (x ? { value: x, label: x } : "")}
              setValue={(x) => x}
              onChange={(name, value) => onChange(name, value)}
            />
          </FormControl>
        </Grid>
        <Grid item xs={isMobile ? 12 : 4}>
          <InputLabel
            sx={{ fontWeight: "bold", color: "black", margin: " 8px 0px" }}
          >
            Partner ID
          </InputLabel>
          <FormControl sx={{ m: 0, width: 200 }}>
            <Input
              fullWidth
              label="Partner ID"
              value={inputs?.employeeNumber?.contains || inputs?.employeeNumber || ""}
              onChange={(e) => onChange("employeeNumber", e.target.value)}
            />
          </FormControl>
        </Grid>
        <Grid item xs={isMobile ? 12 : 4}>
          <InputLabel
            sx={{ fontWeight: "bold", color: "black", margin: " 8px 0px" }}
          >
            Manager ID
          </InputLabel>
          <FormControl sx={{ m: 0, width: 200 }}>
            <Input
              fullWidth
              label="Manager ID"
              value={
                inputs?.supervisorObj?.is?.employeeNumber?.contains ||
                inputs?.supervisorObj ||
                ""
              }
              onChange={({ target: { value } }) => {
                if (value) {
                  onChange("supervisorObj", { is: { employeeNumber: { contains: value } } });
                } else {
                  onChange("supervisorObj", null);
                }
              }}
            />
          </FormControl>
        </Grid>
      </Grid>
    );
  }

  if (location === "followups") {
    return (
      <Grid container columnSpacing={1} rowSpacing={2}>
        <Grid item xs={isMobile ? 12 : 4}>
          <InputLabel
            sx={{ fontWeight: "bold", color: "black", margin: " 8px 0px" }}
          >
            Partner First Name
          </InputLabel>
          <FormControl sx={{ m: 0, width: 200 }}>
            <Input
              fullWidth
              label="Partner First Name"
              value={inputs?.firstName?.contains || inputs?.firstName || ""}
              onChange={(e) => onChange("firstName", e.target.value)}
            />
          </FormControl>
        </Grid>
        <Grid item xs={isMobile ? 12 : 4}>
          <InputLabel
            sx={{ fontWeight: "bold", color: "black", margin: " 8px 0px" }}
          >
            Partner Last Name
          </InputLabel>
          <FormControl sx={{ m: 0, width: 200 }}>
            <Input
              fullWidth
              label="Partner Last Name"
              value={inputs?.lastName?.contains || inputs?.lastName || ""}
              onChange={(e) => onChange("lastName", e.target.value)}
            />
          </FormControl>
        </Grid>
        <Grid item xs={isMobile ? 12 : 4}>
          <FormControl
            sx={{ m: 0, minWidth: 120, marginTop: "8px" }}
            variant="standard"
          >
            <EmployeeSelectAlt
              showBlank
              useName
              label="Assigned to"
              name="assignedTo"
              placeholder="Assigned to"
              value={
                inputs?.followups?.some?.assignedToUser?.is?.OR ? 
                  // Extract name from OR condition
                  (() => {
                    const orCondition = inputs.followups.some.assignedToUser.is.OR;
                    const firstNameCondition = orCondition?.find(condition => condition.firstName);
                    const lastNameCondition = orCondition?.find(condition => condition.lastName);
                    if (firstNameCondition && lastNameCondition) {
                      return `${firstNameCondition.firstName.equals} ${lastNameCondition.lastName.equals}`;
                    }
                    return "";
                  })() :
                inputs?.assignedTo ||
                ""
              }
              onChange={(name, value) => {
                if (value) {
                  // Split the full name into first and last name
                  const nameParts = value.trim().split(' ');
                  const firstName = nameParts[0];
                  const lastName = nameParts.slice(1).join(' '); // Handle middle names
                  
                  onChange("followups", {
                    some: {
                      assignedToUser: {
                        is: {
                          OR: [
                            // Match exact first and last name combination
                            {
                              firstName: { equals: firstName },
                              lastName: { equals: lastName }
                            },
                            // Fallback: match if only first name provided
                            ...(lastName ? [] : [{ firstName: { equals: firstName } }])
                          ]
                        }
                      }
                    }
                  });
                } else {
                  onChange("followups", null);
                }
              }}
            />
          </FormControl>
        </Grid>
      </Grid>
    );
  }

  if (location === "reviewCycles") {
    return (
      <Grid container columnSpacing={1} rowSpacing={2}>
        <Grid item xs={isMobile ? 12 : 4}>
          <InputLabel
            sx={{ fontWeight: "bold", color: "black", marginBottom: "8px" }}
          >
            Name
          </InputLabel>
          <FormControl sx={{ m: 0, width: 200 }}>
            <Input
              fullWidth
              label="Name"
              value={inputs?.name?.contains || inputs?.name || ""}
              onChange={(e) => onChange("name", e.target.value)}
            />
            {/*  User */}
          </FormControl>
        </Grid>
        <Grid item xs={isMobile ? 12 : 4}>
          <DateRangePicker
            label="Start Date"
            name="startDate"
            value={inputs?.startDate}
            onChange={onChange}
          />
        </Grid>
        <Grid item xs={isMobile ? 12 : 4}>
          <FormControl sx={{ m: 0, width: 200, marginLeft: "-8px" }}>
            <GroupCycleSelect
              filterHeight
              showBlank
              label="Group Cycle"
              name="groupCycle"
              size="medium"
              sx={{ height: "36px" }}
              value={inputs?.groupCycle?.equals || inputs?.groupCycle || ""}
              onChange={onChange}
            />
          </FormControl>
        </Grid>
      </Grid>
    );
  }

  return (
    <Grid container columnSpacing={1} rowSpacing={2}>
      <Grid item xs={4}>
        <span>No Filters</span>
      </Grid>
    </Grid>
  );
}

SearchFiltersForm.propTypes = {
  inputs: PropTypes.any.isRequired,
  onChange: PropTypes.func.isRequired,
  location: PropTypes.string.isRequired,
  setFilters: PropTypes.func.isRequired,
};

export default SearchFiltersForm;
